export const getQrBoxSize = (ref: React.RefObject<HTMLElement>) => {
    if (!ref.current) {
        return { width: 150, height: 250 }
    }

    const containerWidth = ref.current.clientWidth
    const containerHeight = ref.current.clientHeight

    return {
        width: containerWidth * 0.8,
        height: containerHeight
    }
}

export const validatePermissionError = (error: Error | string | unknown) => {
    return (
        typeof error === 'string' &&
        (error.includes('NotAllowedError') ||
            error.includes('Permission denied') ||
            error.includes('PermissionDeniedError'))
    )
}
